var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        filter: url(#filter);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 1232,
    y: 5106,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "network.svg",
    className: "cls-1",
    d: "M1254.27,5106a2.729,2.729,0,0,0-2.4,4.03l-4.46,4.47a3.618,3.618,0,0,0-4.45-.01l-3.49-3.48a1.793,1.793,0,0,0,.26-0.92,1.82,1.82,0,1,0-1.82,1.82,1.793,1.793,0,0,0,.92-0.26l3.48,3.49a3.57,3.57,0,0,0-.76,2.22,3.62,3.62,0,0,0,.76,2.23l-5.75,5.76a2.654,2.654,0,1,0,.57.71l5.83-5.83a3.687,3.687,0,0,0,1.77.74v4.62a2.725,2.725,0,1,0,.91,0v-4.62a3.687,3.687,0,0,0,1.77-.74l3.48,3.49a1.785,1.785,0,0,0-.25.92,1.815,1.815,0,1,0,1.81-1.82,1.785,1.785,0,0,0-.91.26l-3.49-3.49a3.628,3.628,0,0,0,.77-2.23,3.578,3.578,0,0,0-.77-2.22l4.39-4.4A2.725,2.725,0,1,0,1254.27,5106Zm-17.27,4.09a0.91,0.91,0,1,1,.91.91A0.913,0.913,0,0,1,1237,5110.09Zm-2.27,19.09a1.815,1.815,0,1,1,1.82-1.82A1.827,1.827,0,0,1,1234.73,5129.18Zm12.27-.91a1.82,1.82,0,1,1-1.82-1.82A1.827,1.827,0,0,1,1247,5128.27Zm-1.82-8.18a2.725,2.725,0,1,1,2.73-2.73A2.734,2.734,0,0,1,1245.18,5120.09Zm8.18,4.55a0.91,0.91,0,1,1-.91-0.91A0.907,0.907,0,0,1,1253.36,5124.64Zm0.91-14.09a1.82,1.82,0,1,1,1.82-1.82A1.827,1.827,0,0,1,1254.27,5110.55Z",
    transform: "translate(-1232 -5106)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.85385c0763ef622d26da6ccbae6d7992.svg";
export { ForwardRef as ReactComponent };